import { AfterViewInit, Component, EventEmitter, OnChanges, OnInit, Output, input, model, output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router';
import { faArrowUpRightFromSquare, faWarning } from '@fortawesome/free-solid-svg-icons';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Editor, Toolbar } from 'ngx-editor';
import { Subject } from 'rxjs';
import { ReportService } from 'src/app/services/report.service';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { ReportForest } from 'src/app/models/reportForest.model';
import { APP_CONSTANTS } from 'src/app/shared/app.constants';
import { AutoSaveComponent } from '../../report-2500-8/auto-save/auto-save.component';
import { NAFilterPipe } from 'src/pipes/naFilter.pipe';
import { AccomplishmentService } from 'src/app/services/accomplishment.service';
import { MatAccordion } from '@angular/material/expansion';

@Component({
  selector: 'app-accomplishment-treatments',
  templateUrl: './accomplishment-treatments.component.html',
  styleUrls: ['./accomplishment-treatments.component.scss'],
  standalone: false
})

export class AccomplishmentTreatmentsComponent extends AutoSaveComponent implements OnChanges, OnInit, AfterViewInit {
  //icons
  faWarning = faWarning;
  faCircleXmark = faCircleXmark as IconProp;
  faArrowUpRightFromSquare = faArrowUpRightFromSquare;

  html = "<p>Hello</p>"
  open = false;

  report = input.required<any>();
  reportList = input.required<any>();
  nav = model.required<string>();
  status = output<number | undefined>();
  @Output() loaded = new EventEmitter();
  errorList: string[] = [];
  saveSubject = new Subject<any>();
  toolbar: Toolbar = APP_CONSTANTS.EDITOR_TOOLBAR;

  totalUnits = 0;
  totalFunding = 0;

  treatmentList: any[] = [];
  treatmentTypes: any[] = [];

  methods = [
    { method_id: 0, method: 'Contract' },
    { method_id: 1, method: 'Agreement' },
    { method_id: 2, method: 'Force Account' }
  ]
  contract_status_list = [
    { contract_status_id: 0, contract_status: 'Pre-Award' },
    { contract_status_id: 1, contract_status: 'Awarded' },
    { contract_status_id: 2, contract_status: 'Implementing' },
    { contract_status_id: 3, contract_status: 'Work Completed' }
  ]

  form = this.formBuilder.group({
    report_name: [""],
    report_type: [""],
    h_code: ["", Validators.maxLength(10)],
    date_contained: [null] as unknown as Date[],
    prepared_name: ["", Validators.maxLength(50)],
    prepared_address: ["", Validators.maxLength(100)],
    prepared_number: ["", Validators.maxLength(15)],
  });

  constructor(
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    public readonly reportService: ReportService,
    public readonly accomplishmentService: AccomplishmentService,
    private readonly toast: ConfirmationToastComponent,
    private readonly naFilter: NAFilterPipe,
  ) {
    super();
  }
  ngAfterViewInit(): void {
    this.loaded.emit(true);
  }

  ngOnInit(): void {
    this.setupData();
    this.formReady = true;
  }

  ngOnChanges(): void {
    if (this.nav() != '') this.navigate();
  }

  navigate() {
    this.save(true);
  }

  route() {
    switch (this.nav()) {
      case 'forward': {
        this.router.navigate(['/report-accomplishment'], { queryParams: { accomplishment_id: this.report().accomplishment_id, report_page_input: 3 } });
        break;
      }
      case 'back': {
        this.router.navigate(['/report-accomplishment'], { queryParams: { accomplishment_id: this.report().accomplishment_id, report_page_input: 1 } });
        break;
      }
      case 'close': {
        this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.reportList()[0].assessment_id, tab: 2 } });
        break;
      }
      default: {
        if (Number(this.nav()))
          this.router.navigate(['/report-accomplishment'], { queryParams: { accomplishment_id: this.report().accomplishment_id, report_page_input: this.nav() } });
        break;
      }
    }
  }

  onChangeEditor(html: any, field: any) {
    if (html == '<p></p>') {
      let patch = '{"status_statement": ""}'
      this.treatmentList.find((treatment: any) => treatment.accomplishment_treatment_id == field.accomplishment_treatment_id).form.patchValue(JSON.parse(patch))
    }
  }

  setupData() {
    let totalFunding = 0;
    let totalUnits = 0;
    this.reportList().forEach((report: any) => {
      report.forests.forEach((forest: ReportForest) => {
        let totalItem = this.forestTotal(forest.treatments, forest.forest_name);
        totalFunding += totalItem.totalFunding;
        totalUnits += totalItem.totalUnits;
      });
    })
    this.totalFunding = totalFunding;
    this.totalUnits = totalUnits;

    this.treatmentTypes = this.treatmentTypes.reduce((acc, curr) => {
      if(!(acc.some((item: any) => item.treatment_type_id === curr.treatment_type_id)))
        acc.push(curr);
      return acc;
    }, <any>[]);
  }

  forestTotal(treatments: any[] | undefined, forest_name: string | undefined) {
    let totalFunding = 0;
    let totalUnits = 0;

    if (treatments == null) return {
      totalFunding,
      totalUnits,
    };
    for (let item of treatments) {
      this.treatmentTypes.push(item.treatment_type)
      //compute totals
      let totalItem = this.unitTotal(item.treatment_specifications[0]) || 0; // ?? Does not cover NaN
      totalFunding += totalItem.totalFunding;
      totalUnits += totalItem.totalUnits;
      //create form per treatment
      let treatmentData = this.report().accomplishment_treatments.find((data: any) => data.forest_treatment_id == item.forest_treatment_id)
      let form = this.formBuilder.group({
        units: [treatmentData?.units, Validators.max(totalItem.totalUnits)],
        date_completed: [treatmentData?.date_completed],
        method_id: [treatmentData?.method_id],
        contract_id: [treatmentData?.contract_id],
        contract_status_id: [treatmentData?.contract_status_id],
        agreement: [treatmentData?.agreement],
        status_statement: [this.customATOB(treatmentData?.status_statement ?? ""), [Validators.maxLength(6000), Validators.required]],
      })
      this.treatmentList.push({
        form: form,
        treatment: item,
        totalUnits: totalItem.totalUnits,
        totalFunding: totalItem.totalFunding,
        accomplishment_treatment_id: treatmentData?.accomplishment_treatment_id,
        forest_name: forest_name,
        editor: new Editor(),
      })
      this.listenForChanges(form)
    }
    return {
      totalFunding,
      totalUnits,
    };
  }

  unitTotal(item: any) {
    return {
      totalFunding: (item.approved_unit_cost * item.approved_unit_qty) + (item.wo_approved_unit_cost * item.wo_approved_unit_qty),
      totalUnits: (item.approved_unit_qty ?? 0) + (item.wo_approved_unit_qty ?? 0),
    };
  }

  override save(navigate?: boolean) {
    this.navDebounceCheck(navigate)
    let data = this.gatherData();

    if (!navigate && this.checkIfNotNeedToSave(data)) return

    this.saveSubject.next(null)
    this.status.emit(data.allFieldsFilled ? 2 : 1);


    this.accomplishmentService.updateAccomplishment({
      accomplishment_id: this.report().accomplishment_id,
      page_2_status_id: data.allFieldsFilled ? 2 : 1,
    }).subscribe({
      next: (response) => {
        if (navigate) {
            this.route(); // navigate route after save because next page needs to see this page's changes
        } else {
          this.postSave();
        }
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`There was an error saving the report`, "Please try again.");
      },
      complete: () => {
        this.form.markAsPristine();
        if (navigate) this.navDebounce = false
      }
    })
  }

  gatherData(): any {
    let data: { dataList: any[], allFieldsFilled: boolean } = { dataList: [], allFieldsFilled: true };
    for (let treatment of this.treatmentList) {
      if (((treatment.form?.value?.units ?? -1) === -1)
        || (treatment.form?.value?.date_completed == null)
        || (treatment.form?.value?.method_id == null)
        || ((treatment.form?.value?.method_id == 0) && (((treatment.form?.value?.contract_id ?? '') == '') || (treatment.form?.value?.contract_status_id == null)))
        || ((treatment.form?.value?.method_id == 1) && ((treatment.form?.value?.agreement ?? '') == ''))
        || (treatment.form?.value?.status_statement == '')
      ) {
        data.allFieldsFilled = false
      }
      if (treatment.accomplishment_treatment_id) {
        const form = this.UpdateAccomplishmentTreatment(treatment);
        data.dataList.push(form);
      }
      else {
        const form = this.NewAccomplishmentTreatment(treatment);
        data.dataList.push(form);
      }
    }
    return data;
  }

  NewAccomplishmentTreatment(treatment: any) {
    let data = {
      accomplishment_id: this.report().accomplishment_id,
      forest_treatment_id: treatment.treatment.forest_treatment_id,
      method_id: treatment.form.value.method_id,
      units: treatment.form.value.units,
      date_completed: treatment.form.value.date_completed,
      status_statement: treatment.form.value.status_statement,
      contract_id: treatment.form.value.contract_id,
      agreement: treatment.form.value.agreement,
      contract_status_id: treatment.form.value.contract_status_id
    }
    this.accomplishmentService.createAccomplishmentTreatment(data).subscribe((resp) => {
      treatment.accomplishment_treatment_id = resp.accomplishment_treatment_id;
    })
    return data;
  }

  UpdateAccomplishmentTreatment(treatment: any) {
    let data = {
      accomplishment_treatment_id: treatment.accomplishment_treatment_id,
      forest_treatment_id: treatment.treatment.forest_treatment_id,
      method_id: treatment.form.value.method_id,
      units: treatment.form.value.units,
      date_completed: this.getCompliantDate(treatment.form.value.date_completed),
      status_statement: treatment.form.value.status_statement,
      contract_id: treatment.form.value.contract_id,
      agreement: treatment.form.value.agreement,
      contract_status_id: treatment.form.value.contract_status_id
    }
    this.accomplishmentService.updateAccomplishmentTreatment(data).subscribe();
    return data;
  }

  private getCompliantDate(rawDate: string): string | undefined {
    return rawDate ? new Date(rawDate).toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      timeZone: 'UTC'
    }) : undefined;
  }

  save_close() {
    this.save();
    this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.report().assessment_id } });
  }

  formatDate(date: Date) {
    let year = date.getFullYear();

    let month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;

    let day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    return month + '/' + day + '/' + year;
  }

  customATOB(s: string): string {
    try {
      return atob(s)
    } catch (err) {
      if (err) {
        return s
      }
    }
    return s
  }

  customBTOA(s: string): string {
    return btoa(s.replaceAll(/[\u00A0-\u2666]/g, function (c) {
      return '&#' + c.codePointAt(0) + ';';
    }));
  }

  onTreatmentClick(event: MouseEvent, accordion: MatAccordion): void {
    if (event.ctrlKey) {
      if (accordion._stateChanges.closed) {
        accordion.openAll();
        accordion._stateChanges.closed = false;

      }
      else {
        accordion.closeAll();
        accordion._stateChanges.closed = true;
      }
    }
  }

  onTreatmentKeypress(event: any, accordion: MatAccordion): void {
    if (event.ctrlKey && event.key === "Enter") {
      if (accordion._stateChanges.closed) {
        accordion.openAll();
        accordion._stateChanges.closed = false;

      }
      else {
        accordion.closeAll();
        accordion._stateChanges.closed = true;
      }
    }
  }

  calcTotalAuth(treatment: any) {
    const spec = treatment.treatment.treatment_specifications[0];
    return (spec.approved_unit_cost * spec.approved_unit_qty) + (spec.wo_approved_unit_cost * spec.wo_approved_unit_qty);
  }

  calcTotalCompleted(treatment: any) {
    const units = treatment.form.value.units;
    const spec = treatment.treatment.treatment_specifications[0];
    let total = 0;
    let unitsLeft = units - spec.approved_unit_qty;
    if (unitsLeft > 0) { //leftover gets used against wo approval
      total = (spec.approved_unit_cost * spec.approved_unit_qty) + (spec.wo_approved_unit_cost * units);
    } else { //only use ro ammount. below or equal to approved amount
      total = (spec.approved_unit_cost * units);
    }
    return total;
  }

  totalCompletedUnits() {
    let totalUnits = 0;
    for(let treatment of this.treatmentList) {
      totalUnits += treatment.form.value.units ?? 0;
    }
    return totalUnits;
  }

  totalCompletedFunding() {
    let total = 0;
    for(let treatment of this.treatmentList) {
      total += this.calcTotalCompleted(treatment);
    }
    return total;
  }
}
